<template>
  <div type="flex">
    <div id="otpContainer">
      <otp-input
        ref="otpValue"
        input-classes="otp-input"
        :num-inputs="6"
        :should-auto-focus="true"
        :is-input-num="true"
        separator="-"
        :is-disabled="disableInput"
        @on-complete="handleOtpComplete"
        @on-change="handleOtpChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disableInput: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update-otp-value', 'otp-enter-complete'],
  methods: {
    handleOtpChange(enteredOtp) {
      this.$emit('update-otp-value', enteredOtp);
    },
    handleOtpComplete(enteredOtp){
      this.$emit('update-otp-value', enteredOtp);
      this.$emit('otp-enter-complete')
    },
    clearInput() {
      this.$refs.otpValue.clearInput();
    },
  },
};
</script>

<style scoped>
#otpContainer {
  padding: 10px 40px;
}

::v-deep(.otp-input) {
  width: 40px;
  height: 40px;
  padding: 10px 10px;
  margin: 0 10px 10px 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}

::v-deep(.otp-input.is-complete) {
  background-color: #e4e4e4;
}

::v-deep(.otp-input::-webkit-inner-spin-button),
::v-deep(.otp-input::-webkit-outer-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}

::v-deep(#otpContainer input::placeholder) {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}
</style>